import React from 'react';
import { Box } from '@mui/material';
import SubjectCard from './SubjectCard';
import { subjectService } from '../services/subjectService';
import { useState, useEffect } from 'react';
import { TextField, InputAdornment, Button, Typography } from '@mui/material';
import { Search as SearchIcon, Add as AddIcon } from '@mui/icons-material';
import MarkdownHelp from './MarkdownHelp';
import AddSubjectDialog from './AddSubjectDialog';
import CustomAppBar from './CustomAppBar';

const SubjectList = () => {
  const [subjects, setSubjects] = useState([]);
  const [addSubjectOpen, setAddSubjectOpen] = useState(false);
  // const [searchText, setSearchText] = useState('');

  const fetchSubjects = async () => {
    const subjects = await subjectService.getAllSubjects();
    setSubjects(subjects);
  };

  useEffect(() => {
    fetchSubjects();
  }, []);


  return (
    <CustomAppBar>
      <AddSubjectDialog open={addSubjectOpen} onClose={() => setAddSubjectOpen(false)} onAdd={() => fetchSubjects()} />
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 4,
        flexWrap: 'wrap',
        gap: 2
      }}>
        <Box>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}>
            Your Subjects
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
            Manage your subjects.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* <TextField
            variant="outlined"
            size="small"
            placeholder="Search topics, questions, answers..."
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              sx: { borderRadius: 2, bgcolor: 'background.paper', minWidth: 260 }
            }}
            sx={{ mr: 2 }}
          />
          <MarkdownHelp /> */}
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setAddSubjectOpen(true)}
            sx={{
              px: 3,
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 600,
              borderRadius: 2,
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)',
              '&:hover': {
                boxShadow: '0 6px 16px rgba(37, 99, 235, 0.4)',
              }
            }}
          >
            Add Subject
          </Button>
        </Box>
      </Box>
      <Box>
        {subjects.map((subject) => (
          <SubjectCard
            key={subject.id}
            subject={subject}
            fetchSubjects={fetchSubjects}
          />
        ))}
      </Box>
    </CustomAppBar>
  );
};

export default SubjectList;
